import Vue from 'vue';
import App from './App.vue';
import router from './router';
import i18n from '@/translations';

import Vue2TouchEvents from 'vue2-touch-events';
import anime from 'animejs';

Vue.config.productionTip = false;

Vue.use(Vue2TouchEvents);

const uaId = 'UA-161925058-4';

Vue.mixin({
  data: function (){
    return {
      uaId: uaId,
    }
  },
  methods: {
    isIpadOS: function(){
      return navigator.maxTouchPoints &&
        navigator.maxTouchPoints > 2 &&
        /MacIntel/.test(navigator.platform);
    },
    /**
     * detect Mobile
     */
    mobileAndTabletcheck: function () {
      var check = false;
      //eslint-disable-next-line
      (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
      return check;
    },
    /**
     * detect IE
     * returns version of IE or false, if browser is not Internet Explorer
     */
    detectIE: function() {
      var ua = window.navigator.userAgent;

      // Test values; Uncomment to check result …

      // IE 10
      // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';

      // IE 11
      // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';

      // Edge 12 (Spartan)
      // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';

      // Edge 13
      // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

      var msie = ua.indexOf('MSIE ');
      if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
      }

      var trident = ua.indexOf('Trident/');
      if (trident > 0) {
        // IE 11 => return version number
        var rv = ua.indexOf('rv:');
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
      }

      var edge = ua.indexOf('Edge/');
      if (edge > 0) {
        // Edge (IE 12+) => return version number
        return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
      }

      // other browser
      return false;
    },
    closest: function(el, selector) {
      var matchesSelector = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;

      while (el) {
        if (matchesSelector.call(el, selector)) {
          break;
        }
        el = el.parentElement;
      }
        return el;
    },
    isPageZoomed: function () {
      var zoomed = document.documentElement.clientWidth / window.innerWidth
      //console.log('zoomed',zoomed);
      if(zoomed > 1.05) {
        return true
      } else {
        return false
      }
    },
    removePageMask: function() {
      document.getElementById('page-mask').remove()
    },
    getScrollbarWidth: function() {
      var outer = document.createElement('div');
      outer.style.visibility = 'hidden';
      outer.style.width = '100px';
      outer.style.msOverflowStyle = 'scrollbar';

      document.body.appendChild(outer);

      var widthNoScroll = outer.offsetWidth;
      outer.style.overflow = 'scroll';

      var inner = document.createElement('div');
      inner.style.width = '100%';
      outer.appendChild(inner);

      var widthWithScroll = inner.offsetWidth;

      outer.parentNode.removeChild(outer);
      return widthNoScroll - widthWithScroll;
    },
    setWorkBgPos: function() {
      document.querySelector('.work__bg').style.left = Math.floor(Math.random() * -100) + '%';
    },
    aniMenuPageLeave:function (goToNextPage){
      if(document.querySelector('.hm-open-menu').classList.contains('active')){
        document.querySelector('.hm-open-menu').classList.remove('active');
        document.querySelector('.hm-close-menu').classList.remove('active');
        document.querySelector('.menu-overlay').classList.remove('active');
        setTimeout(function (){
          goToNextPage;
        },520);
      } else {
        goToNextPage;
      }
    },
    closeWorkShare: function (e){
      if(document.querySelector('.work-page').classList.contains('detail-loaded')){
        if(!e.target.classList.contains('share-button') && !e.target.classList.contains('share-butto__item')){
          document.querySelector('.top-tool-nav-wrap .share-button').classList.remove('open');

        }
      }
    },
    aniPageLeave: function (e){
      anime({
        targets: document.querySelector('.mond__content-wrap'),
        scale: 0.7,
        translateY: '-15%',
        duration: 500,
        opacity: {
          value:0.3,
          duration: 300,
          delay:200
        },
        easing:'easeOutSine',
        complete: function() {
          location.href = e.target.getAttribute('data-href')
        }
      });
      anime({
        targets: ['.range-slider', '.mond__legend'],
        opacity: 0,
        duration: 200,
        easing:'easeOutSine'
      })
      anime({
        targets: ['.detail__bg'],
        opacity: 0.5,
        duration: 300,
        delay:200,
        easing:'easeOutSine'
      });
    },
    saveCurrentPlanetToLocalStorage: function() {
      let selSlide = this.slides.findIndex(x => x.url === this.$route.path.toLowerCase().split('/').pop());

      if(selSlide) {
        localStorage.AstroActivePlanet = selSlide
      } else {
        localStorage.AstroActivePlanet = 0;
      }
    },/* Thanks for:  http://jsfiddle.net/ARTsinn/eWVRH/*/
    Particle: function (x, y, mass) {
      this.x = x || 0;
      this.y = y || 0;
      this.ox = this.x;
      this.oy = this.y;
      this.mass = mass || 1.0;
      this.massInv = 1.0 / this.mass;
      this.fixed = false;

      this.update = function () {};
    },
    Spring: function(p1, p2, restLength, strength) {
      this.p1 = p1;
      this.p2 = p2;
      this.restLength = restLength || 10;
      this.strength = strength || 1.0;

      this.update = function () {

        // Compute desired force
        var dx = p2.x - p1.x,
          dy = p2.y - p1.y,
          dd = Math.sqrt(dx * dx + dy * dy) + 0.0001,
          tf = (dd - this.restLength) / (dd * (p1.massInv + p2.massInv)) * this.strength,
          f;

        // Apply forces
        if (!p1.fixed) {
          f = tf * p1.massInv;
          p1.x += dx * f;
          p1.y += dy * f;
        }

        if (!p2.fixed) {
          f = -tf * p2.massInv;
          p2.x += dx * f;
          p2.y += dy * f;
        }
      };
    },
    Sim: function() {
      this.particles = [];
      this.springs = [];

      this.tick = function () {
        var p = this.particles.length;
        while (p--) this.particles[p].update();

        var s = this.springs.length;
        while (s--) this.springs[s].update();
      };
    }
  },
});

router.beforeEach((to, from, next) => {
  // Google Analytics

  // eslint-disable-next-line no-undef
  gtag('config', uaId, {'page_path': to.path});

  let lang = to.params.lang;
  if(!lang) {
    lang = 'de';
  }

  i18n.locale = lang;

  // Meta Tags
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
  //const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if(nearestWithTitle) document.title = nearestWithTitle.meta.title;

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

  // Skip rendering meta tags if there are none.
  if(!nearestWithMeta) return next();

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags.map(tagDef => {
    const tag = document.createElement('meta');

    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, i18n.t(tagDef[key]));
    });

    // We use this to track which meta tags we create, so we don't interfere with other ones.
    tag.setAttribute('data-vue-router-controlled', '');

    return tag;
  })
    // Add the meta tags to the document head.
    .forEach(tag => document.head.appendChild(tag));



  next()
})



new Vue({
  router,
  i18n,
  render: (h) => h(App),
  created() {
    document.getElementById('splash').remove();

    // Get IE or Edge browser version
    var version = this.detectIE();

    if (version === false) {
      document.querySelector('html').classList.add('noIE');
      var iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
      if(iOS) {
        document.querySelector('html').classList.add('isIOS');
      }
    } else if (version >= 12) {
      document.querySelector('html').classList.add('isEdge');
    } else {
      document.querySelector('html').classList.add('isIE');
    }

    document.addEventListener('touchstart', function () {
      var htmlElement = document.querySelector("html");

      if(!htmlElement.classList.contains('has-touch')) {
        htmlElement.classList.add('has-touch');
        window.localStorage.setItem('hasTouch', true);
      }
    }, { passive: false });

    //pinch deactivate -> only zoom page native pinch
    document.addEventListener('touchmove', function (event) {
      //var hasNativPinch = closest(event.target,'.native-pinch');
      // if(hasNativPinch == null) {
      if(event.touches.length > 1 ) {
        event.preventDefault();
      }
      // }
    }, { passive: false });

    document.addEventListener('DOMContentLoaded', function () {
      if(window.localStorage.getItem('hasTouch') == 'true') {
        document.querySelector("html").classList.add('has-touch');
      }
    }, { passive: false });
  },

  methods: {
    beforeLeave: function(to, from, next) {
      document.querySelector('body').classList.remove('page-fade-in')
      document.querySelector('body').classList.add('page-fade-out')
      setTimeout(next, 300);
    },
    afterLoad: function() {
      document.querySelector('body').classList.remove('page-fade-out')
      document.querySelector('body').classList.add('page-fade-in')
    }
  },
  mounted() {
    localStorage.AstroActivePlanet = '';
    this.$router.beforeEach(this.beforeLeave);
    this.$router.afterEach(this.afterLoad);
  }
}).$mount('#app');

require('./assets/js/freqtimeupdate');
